<template>
    <div>
        <el-card>
            <el-row>
                <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>绩效管理</el-breadcrumb-item>
                </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
                <el-col v-if="currentRole.Key!='IDC'&&currentRole.Key!='HR'" :span='2'>
                    <el-button type="primary" @click="goBack('/KPI/KPISetting')" icon="el-icon-setting" plain circle></el-button>
                </el-col>
                <el-col v-if="currentRole.Key=='director'||currentRole.Key=='user'||currentRole.Key=='Manager'||currentRole.Key=='admin'" :span='2'>
                    <el-button type="success" @click="goBack('/KPI/SelfJuge')" icon="el-icon-edit" plain circle></el-button>
                </el-col>
                <el-col v-if="currentRole.Key=='director'||currentRole.Key=='CEO'||currentRole.Key=='Manager'||currentRole.Key=='admin'" :span='2'>
                    <el-button type="warning" @click="goBack('/KPI/JugeByLeader')" icon="el-icon-edit-outline" plain circle></el-button>
                </el-col>
                <el-col v-if="currentRole.Key=='director'||currentRole.Key=='user'||currentRole.Key=='Manager'||currentRole.Key=='admin'" :span='2'>
                    <el-button type="primary" @click="goBack('/KPI/MyKPI')" icon="el-icon-user" plain circle></el-button>
                </el-col>
                <el-col v-if="currentRole.Key=='director'||currentRole.Key=='CEO'||currentRole.Key=='Manager'||currentRole.Key=='admin'" :span='2'>
                    <el-button type="danger" @click="goBack('/KPI/StaffKPI')" icon="el-icon-user" plain circle></el-button>
                </el-col>
                <el-col v-if="currentRole.Key=='director'||currentRole.Key=='admin'" :span='2'>
                    <el-button type="info" @click="goBack('/KPI/LookKPIScore')" icon="el-icon-c-scale-to-original" plain circle></el-button>
                </el-col>
                <el-col v-if="currentRole.Key=='director'||currentRole.Key=='admin'" :span='2'>
                    <el-button type="primary" @click="goBack('/KPI/LookKPI')" icon="el-icon-view" plain circle></el-button>
                </el-col>
                <el-col v-if="currentRole.Key=='director'||currentRole.Key=='admin'" :span='2'>
                    <el-button type="success" @click="goBack('/KPI/LookKPIResult')" icon="el-icon-view" plain circle></el-button>
                </el-col>
                <el-col v-if="currentRole.Key=='IDC'||currentRole.Key=='HR'||currentRole.Key=='CEO'||currentRole.Key=='admin'" :span='2'>
                    <el-button type="danger" @click="goBack('/KPI/AuditKPI')" icon="el-icon-finished" plain circle></el-button>
                </el-col>
            </el-row>
            <el-row>
                <el-col v-if="currentRole.Key!='IDC'&&currentRole.Key!='HR'"  :span='2'>
                    <div class="sub">绩效设置</div> 
                </el-col>
                <el-col v-if="currentRole.Key=='director'||currentRole.Key=='user'||currentRole.Key=='Manager'||currentRole.Key=='admin'" :span='2'>
                    <div class="sub">自评KPI</div> 
                </el-col>
                <el-col v-if="currentRole.Key=='director'||currentRole.Key=='CEO'||currentRole.Key=='Manager'||currentRole.Key=='admin'" :span='2'>
                    <div class="sub">需我评分</div> 
                </el-col>
                <el-col v-if="currentRole.Key=='director'||currentRole.Key=='user'||currentRole.Key=='Manager'||currentRole.Key=='admin'" :span='2'>
                    <div class="sub">我的KPI</div> 
                </el-col>
                <el-col v-if="currentRole.Key=='director'||currentRole.Key=='CEO'||currentRole.Key=='Manager'||currentRole.Key=='admin'" :span='2'>
                    <div class="sub">员工KPI</div> 
                </el-col>
                <el-col v-if="currentRole.Key=='director'||currentRole.Key=='admin'" :span='2'>
                    <div class="sub">历史总分</div> 
                </el-col>
                <el-col v-if="currentRole.Key=='director'||currentRole.Key=='admin'" :span='2'>
                    <div class="sub">查看KPI</div> 
                </el-col>
                <el-col v-if="currentRole.Key=='director'||currentRole.Key=='admin'" :span='2'>
                    <div class="sub">查看KPI结果</div> 
                </el-col>
                <el-col v-if="currentRole.Key=='IDC'||currentRole.Key=='HR'||currentRole.Key=='CEO'||currentRole.Key=='admin'" :span='2'>
                    <div class="sub">审核KPI</div> 
                </el-col>
            </el-row>
        </el-card>
        <!-- <el-card>
          
              <img hidden="hidden" width="199px" class="logo" src="" />
       </el-card>        -->
        <el-card style="margin-top:20px;">
            <el-tabs v-model="activeName">
                <el-tab-pane label="月度" name="month">
                    <LastKPIList :pt="0"></LastKPIList>
                </el-tab-pane>
                <el-tab-pane label="季度" name="quarter">
                    <LastKPIList :pt="1"></LastKPIList>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </div>
</template>
<script>
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic"; 
import LastKPIList from "../KPI/LastKPIList";
export default {
    data() {
        return {
            activeName: "month",
            currentRole:{},//当前角色
        };
    },
    created(){
        //获取当前用户角色
        this.getCurrentRole()
    },
    methods:{
        //获取当前用户角色
        getCurrentRole:function(){
            var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
            this.currentRole = JSON.parse(Decrypt(currentUserRole));
        },
        goBack:function(url){
            this.$router.push(url);
        }
    },
    components: {
        LastKPIList
    }
}
</script>
<style lang="less" scoped>
.sub {
  font-size: 12px;
  color: #8f8d8d;
  margin-top: 10px;
}
table{
    width:auto !important;
}
</style>